import { FC } from 'react';
import { CalendarNavigationButton } from '@new/common/ui/TailwindCalendar/components/CalendarWithSlots/CalendarNavigationButton';
import { CalendarDay } from '@new/common/ui/TailwindCalendar/components/CalendarWithSlots/CalendarDay';
import { DAYS_HEADERS } from '@new/common/ui/TailwindCalendar/lib/constants';

interface CalendarDayData {
  date: Date | null;
  dayNumber: number | null;
}

interface CalendarAgendaMonthViewProps {
  monthYearLabel: string;
  days: CalendarDayData[];
  selectedDay: Date;
  today: Date;
  hasSlots: (date: Date | null) => boolean;
  onDayClick: (date: Date) => void;
  onMonthChange: (direction: 'prev' | 'next') => void;
  showAllDates?: boolean;
}

export const CalendarAgendaMonthView: FC<CalendarAgendaMonthViewProps> = ({
  monthYearLabel,
  days,
  selectedDay,
  today,
  hasSlots,
  onDayClick,
  onMonthChange,
  showAllDates = false,
}) => {
  return (
    <div className="flex flex-col gap-5 bg-(--neutral-white-NW900)">
      <div className="flex items-center justify-between">
        <CalendarNavigationButton direction="prev" onClick={() => onMonthChange('prev')} />
        <h3 className="text-base font-bold text-(--neutral-black-NB900)! m-0!">{monthYearLabel}</h3>
        <CalendarNavigationButton direction="next" onClick={() => onMonthChange('next')} />
      </div>

      <div className="grid grid-cols-7 gap-2 text-center text-xs font-medium text-(--neutral-black-NB500)!">
        {DAYS_HEADERS.map((day, idx) => (
          <div key={idx}>{day}</div>
        ))}
      </div>

      <div className="grid grid-cols-7 gap-2">
        {days.map((day, idx) => (
          <CalendarDay
            key={idx}
            date={day.date}
            dayNumber={day.dayNumber}
            selectedDay={selectedDay}
            today={today}
            hasSlots={hasSlots}
            onClick={onDayClick}
            showAllDates={showAllDates}
          />
        ))}
      </div>
    </div>
  );
};
